import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface FontAwesomeIconOption {
  id: string;
  label: string;
  family: string;
  prefix: string;
  style: string;
}

/** Offline fallback so icon pickers keep working if the Font Awesome API is unavailable. */
const LOCAL_ICON_CATALOG: FontAwesomeIconOption[] = [
  { id: 'lightbulb', label: 'Lightbulb', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'star', label: 'Star', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'heart', label: 'Heart', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'handshake', label: 'Handshake', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'leaf', label: 'Leaf', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'seedling', label: 'Seedling', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'scale-balanced', label: 'Scale Balanced', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'gavel', label: 'Gavel', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'users', label: 'Users', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'user-group', label: 'User Group', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'rocket', label: 'Rocket', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'trophy', label: 'Trophy', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'flag', label: 'Flag', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'bullseye', label: 'Bullseye', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'chart-line', label: 'Chart Line', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'chart-simple', label: 'Chart Simple', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'gears', label: 'Gears', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'gear', label: 'Gear', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'shield-halved', label: 'Shield Halved', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'lock', label: 'Lock', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'eye', label: 'Eye', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'globe', label: 'Globe', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'building', label: 'Building', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'plane', label: 'Plane', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'plane-departure', label: 'Plane Departure', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'plane-arrival', label: 'Plane Arrival', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'passport', label: 'Passport', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'suitcase', label: 'Suitcase', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'map-location-dot', label: 'Map Location Dot', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'location-dot', label: 'Location Dot', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'compass', label: 'Compass', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'clock', label: 'Clock', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'calendar', label: 'Calendar', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'check', label: 'Check', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'check-double', label: 'Check Double', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'circle-check', label: 'Circle Check', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'thumbs-up', label: 'Thumbs Up', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'award', label: 'Award', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'medal', label: 'Medal', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'crown', label: 'Crown', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'gem', label: 'Gem', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'fire', label: 'Fire', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'bolt', label: 'Bolt', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'brain', label: 'Brain', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'graduation-cap', label: 'Graduation Cap', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'book', label: 'Book', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'comments', label: 'Comments', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'handshake-angle', label: 'Handshake Angle', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'people-group', label: 'People Group', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'house', label: 'House', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'tree', label: 'Tree', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'recycle', label: 'Recycle', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'earth-americas', label: 'Earth Americas', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'hand-holding-heart', label: 'Hand Holding Heart', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'hands-holding', label: 'Hands Holding', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'balance-scale', label: 'Balance Scale', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'clipboard-check', label: 'Clipboard Check', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'list-check', label: 'List Check', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'sitemap', label: 'Sitemap', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'network-wired', label: 'Network Wired', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'wifi', label: 'Wifi', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'cloud', label: 'Cloud', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'mobile-screen', label: 'Mobile Screen', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'laptop', label: 'Laptop', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'coins', label: 'Coins', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'money-bill', label: 'Money Bill', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'chart-pie', label: 'Chart Pie', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'briefcase', label: 'Briefcase', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'building-columns', label: 'Building Columns', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'landmark', label: 'Landmark', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'mosque', label: 'Mosque', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'sun', label: 'Sun', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'moon', label: 'Moon', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'sparkles', label: 'Sparkles', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'wand-magic-sparkles', label: 'Wand Magic Sparkles', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'infinity', label: 'Infinity', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'puzzle-piece', label: 'Puzzle Piece', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'key', label: 'Key', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'fingerprint', label: 'Fingerprint', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'user-shield', label: 'User Shield', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'person-walking', label: 'Person Walking', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'face-smile', label: 'Face Smile', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'hand-sparkles', label: 'Hand Sparkles', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'mug-hot', label: 'Mug Hot', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'bed', label: 'Bed', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'wheelchair', label: 'Wheelchair', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'child', label: 'Child', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'people-carry-box', label: 'People Carry Box', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'boxes-stacked', label: 'Boxes Stacked', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'truck', label: 'Truck', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'warehouse', label: 'Warehouse', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'industry', label: 'Industry', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'flask', label: 'Flask', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'microscope', label: 'Microscope', family: 'classic', prefix: 'fas', style: 'solid' },
  { id: 'atom', label: 'Atom', family: 'classic', prefix: 'fas', style: 'solid' },
];

@Injectable({
  providedIn: 'root'
})
export class FontAwesomeService {
  private domain = environment.domain;

  constructor(private http: HttpClient) { }

  getIconByQuery(term: string | FontAwesomeIconOption | null | undefined): Observable<{ data: { icons: FontAwesomeIconOption[] } }> {
    const query = this.normalizeQuery(term);
    if (!query) {
      return of({ data: { icons: [] } });
    }

    const params = new HttpParams()
      .set('query', query)
      .set('limit', '200');

    return this.http.get<any>(this.domain + 'icons', { params }).pipe(
      map((response) => {
        const icons = (response?.data?.icons ?? []) as FontAwesomeIconOption[];
        if (icons.length > 0) {
          return { data: { icons } };
        }
        return { data: { icons: this.searchLocal(query) } };
      }),
      catchError(() => of({ data: { icons: this.searchLocal(query) } }))
    );
  }

  parseIconClass(iconClass: string | null | undefined): FontAwesomeIconOption | null {
    if (!iconClass?.trim()) {
      return null;
    }

    const parts = iconClass.trim().split(/\s+/).filter(Boolean);
    const prefix = parts.find((p) => p === 'fas' || p === 'far' || p === 'fab' || p === 'fal' || p === 'fad'
      || p === 'fa-solid' || p === 'fa-regular' || p === 'fa-brands')
      ?? 'fas';
    const idPart = parts.find((p) => p.startsWith('fa-') && !['fa-solid', 'fa-regular', 'fa-brands', 'fa-light', 'fa-duotone'].includes(p));
    const id = idPart ? idPart.replace(/^fa-/, '') : parts.find((p) => !p.startsWith('fa') && p !== prefix);

    if (!id) {
      return null;
    }

    const normalizedPrefix = prefix === 'fa-solid' ? 'fas'
      : prefix === 'fa-regular' ? 'far'
        : prefix === 'fa-brands' ? 'fab'
          : prefix;

    return {
      id,
      label: id.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      family: 'classic',
      prefix: normalizedPrefix,
      style: normalizedPrefix === 'far' ? 'regular' : normalizedPrefix === 'fab' ? 'brands' : 'solid'
    };
  }

  private normalizeQuery(term: string | FontAwesomeIconOption | null | undefined): string {
    if (!term) {
      return '';
    }
    if (typeof term === 'string') {
      return term.trim();
    }
    if (typeof term === 'object') {
      return (term.label || term.id || '').toString().trim();
    }
    return '';
  }

  private searchLocal(query: string): FontAwesomeIconOption[] {
    const q = query.toLowerCase();
    return LOCAL_ICON_CATALOG
      .filter((icon) => icon.id.includes(q) || icon.label.toLowerCase().includes(q))
      .slice(0, 50);
  }
}

export interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
